// import { app_route_ids, app_route_keys } from "constants/urlPaths";
import React from "react";
// import { Redirect } from "react-router-dom";
import { LazyLoadRoutes } from "routes/lazyLoadRoutes";
import ExlyLoader from "ui/modules/ExlyLoader";
import { useIsMediaLibEnabled } from "./utils/useIsMediaLibEnabled";
import FeaturePage from "ui/pages/FeaturePage";
import { RESOURCE_KEYS } from "utils/OrgPermissions";
import { getS3AssetCDNUrl } from "features/Common/modules/File/modules/Upload/utils/FileUpload.utils";
// import { SUBSCRIPTION_PLAN } from "constants/account.constants";

const MediaLibrary = React.lazy(() => import("ui/pages/MediaLibrary"));

export const MediaLibraryRoute = (props) => {
  const { isMediaLibraryEnabled, loading } = useIsMediaLibEnabled();
  // const { location } = props;

  if (loading) return <ExlyLoader />;

  return isMediaLibraryEnabled ? (
    <LazyLoadRoutes LazyElement={MediaLibrary} props={props} />
  ) : (
    // <Redirect
    //   to={{
    //     pathname: app_route_ids[app_route_keys.dashboard],
    //     state: { from: location },
    //   }}
    // />
    <FeaturePage
      featureName={RESOURCE_KEYS.SECTIONS.MEDIA_LIBRARY}
      desktopImage={getS3AssetCDNUrl(
        "assets/images/ct_upfront/media_library.png"
      )}
      mobileImage={getS3AssetCDNUrl(
        "assets/images/ct_upfront/media_library.png" // Add mobile image later
      )}
      pageTitle="Media Library"
      ctaText={`Upgrade Plan`}
    />
  );
};
